import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as o } from "react";
const m = ({
  title: s,
  titleId: c,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...l,
    children: [
      s ? /* @__PURE__ */ e.jsx("title", { id: c, children: s }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M847.755 159.671v64.677h-671.48v-64.677c0-26.328 21.095-47.454 47.128-47.454h156.005V82.998c0-22.133 17.877-40.333 39.943-40.333h185.292c22.103 0 39.975 18.199 39.975 40.333v29.219h156.005c26.001 0 47.128 21.127 47.128 47.454zM715.151 844.046c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.757 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.762 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm485.8-567.443H176.145v657.57c0 26.032 21.095 47.159 47.128 47.159h577.454c26.032 0 47.128-21.127 47.128-47.159V281.022a4.426 4.426 0 0 0-4.422-4.422z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h = o(m);
export {
  h as default
};
